// src/services/agentService.ts
import { supabase } from '../utils/supabaseClient';
import { AgentConfiguration, AgentConfigurationInput } from '../types/agent';

/**
 * Get agent configuration for a branch
 */
export const getAgentConfiguration = async (branchId: string) => {
	return await supabase
		.from('agent_configuration')
		.select('*')
		.eq('branch_id', branchId)
		.maybeSingle();
};

/**
 * Create agent configuration for a branch
 */
export const createAgentConfiguration = async (
	branchId: string,
	config: AgentConfigurationInput
) => {
	return await supabase
		.from('agent_configuration')
		.insert([{
			branch_id: branchId,
			...config
		}])
		.select()
		.single();
};

/**
 * Update agent configuration
 */
export const updateAgentConfiguration = async (
	branchId: string,
	config: Partial<AgentConfigurationInput>
) => {
	return await supabase
		.from('agent_configuration')
		.update({
			...config,
			updated_at: new Date().toISOString()
		})
		.eq('branch_id', branchId)
		.select()
		.single();
};

/**
 * Delete agent configuration
 */
export const deleteAgentConfiguration = async (branchId: string) => {
	return await supabase
		.from('agent_configuration')
		.delete()
		.eq('branch_id', branchId)
		.select()
		.single();
};

/**
 * Upsert agent configuration (create or update)
 */
export const upsertAgentConfiguration = async (
	branchId: string,
	config: AgentConfigurationInput
) => {
	return await supabase
		.from('agent_configuration')
		.upsert([{
			branch_id: branchId,
			...config,
			updated_at: new Date().toISOString()
		}], {
			onConflict: 'branch_id'
		})
		.select()
		.single();
};